// src/config/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// --- JOUW EIGEN FIREBASE CONFIGURATIE ---
const firebaseConfig = {
  apiKey: "AIzaSyCymBV_QzlPlxzxrXIXFqlO-VppjDSqefY",
  authDomain: "auth.bespanapp.nl",
  projectId: "de-tenniswinkel-bespannen",
  storageBucket: "de-tenniswinkel-bespannen.firebasestorage.app",
  messagingSenderId: "20320420853",
  appId: "1:20320420853:web:0a6bd819c3f5ee8c6f96bc"
}; 

// 1. Initialiseer de variabelen. 
// (De ': any' vertelt TypeScript dat we deze later pas invullen, dat voorkomt rode kringeltjes).
let app: any, auth: any, db: any, storage: any, googleProvider: any;
let firebaseInitialized = false;
let firebaseError = null;

// 2. Probeer Firebase te starten
try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app); // <-- TOEGEVOEGD: De stroomkabel voor opslag
    googleProvider = new GoogleAuthProvider();
    firebaseInitialized = true;
} catch (e: any) { 
    console.error("Firebase init error:", e);
    firebaseError = e.message;
}

// 3. Jouw extra constante
const appId = "tennis-winkel-live"; 

// 4. Exporteer alles in één keer, netjes gegroepeerd
export { 
    app, 
    auth, 
    db, 
    storage, // <-- TOEGEVOEGD: We delen de opslag nu met de rest van je app
    googleProvider, 
    firebaseInitialized, 
    firebaseError,
    appId
};